import type React from 'react';

import { ErrorMessage } from '@change/ds-forms';

import { TypedTranslate } from '@change-corgi/core/react/i18n';

import type { UploadErrorProps } from '../../types';

export const UploadError: React.FC<UploadErrorProps> = ({ uploadErrorMessage, errorMessage }) => {
	if (uploadErrorMessage) {
		return (
			<ErrorMessage size="large" className="mt-1" data-testid="upload-error-message">
				<TypedTranslate value={uploadErrorMessage} />
			</ErrorMessage>
		);
	}
	if (errorMessage) {
		return (
			<ErrorMessage size="large" className="mt-1" data-testid="upload-error-message">
				{errorMessage}
			</ErrorMessage>
		);
	}
	return null;
};
